import {createSinglePathSVG} from './TEMPLATE'

export const AlignCenter_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 20 20',
  strokeWidth: 1.67,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  path: 'M15 8.33333H5M17.5 5H2.5M17.5 11.6667H2.5M15 15H5',
})
